import React from 'react';
import BarGraph from './BarGraph';
import Skeleton from 'react-loading-skeleton';

const GraphCard = ({ graphprops, descriptionPoints, loading, loaderHeight }) => {
  if (loading) return <Skeleton width='100%' height={loaderHeight} />;

  return (
    <div className='bg-white overflow-hidden border border-gray-200 rounded-md h-full flex items-center'>
      <div className='w-3/5 h-full inline-block'>
        <BarGraph {...graphprops} />
      </div>
      <div className='border-r border-gray-200 relative left-6 ' style={{ height: '70%', marginBottom: '2%' }}></div>
      <div className='p-5 w-2/5 h-auto flex flex-col'>{descriptionPoints.map((item, index) => <span key={`${item}`+ index}>{item}</span>)}</div>
    </div>
  );
};
export default GraphCard;
